import React from 'react';

function ContactInfo() {
  return (
    <section className="tc-contact-info-style1">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="info-cards">
              <div className="row">
                <div className="col-lg-6">
                 <div className="item mt-50">
  <h6 className="fsz-24 mb-15 fw-bold">Gurugram, Haryana</h6>

  <ul className="color-666 lh-6">
    <li>
      <a
        href="https://maps.app.goo.gl/LxTFPdgzJhT1WmRQ6"
        target="_blank"
        rel="noopener noreferrer"
      >
        G-67, G Block, South City 1, Sector 41, Gurugram, Haryana 122022
      </a>
    </li>

    <li>
      <a href="mailto:info.ssarchitectsandinteriors@gmail.com">
        info.ssarchitectsandinteriors@gmail.com
      </a>
    </li>

    <li>
      <a href="tel:+919599874844">
        +91 95998 74844
      </a>
    </li>
  </ul>
</div>
  </div>
                
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="social-icons mt-50 text-lg-end">
              <a href="#">
                <i className="fab fa-x-twitter"></i>
              </a>
              <a href="#">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="#">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactInfo;
